export function triggerBlobDownload(blob: Blob, filename: string): string {
  const objectUrl = URL.createObjectURL(blob);
  const link = document.createElement('a');

  try {
    link.href = objectUrl;
    link.download = filename;
    // Чтобы не влиять на layout и не ловить фокусы:
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
  } finally {
    link.remove();
    // Небольшая задержка помогает Safari/Firefox корректно завершить навигацию по blob: URL
    setTimeout(() => URL.revokeObjectURL(objectUrl), 0);
  }

  return filename;
}

export function parseFilenameFromContentDisposition(
  contentDisposition?: string,
  defaultFilename = 'export.xlsx'
): string {
  if (!contentDisposition) return defaultFilename;

  const utf8Match = /filename\*\s*=\s*UTF-8''([^;]+)/i.exec(contentDisposition);
  if (utf8Match?.[1]) {
    return decodeURIComponent(utf8Match[1]);
  }

  // filename="example.xlsx"
  const quotedMatch = /filename\s*=\s*"([^"]+)"/i.exec(contentDisposition);
  if (quotedMatch?.[1]) return quotedMatch[1].trim();

  // filename=example.xlsx
  const simpleMatch = /filename\s*=\s*([^;]+)/i.exec(contentDisposition);
  if (simpleMatch?.[1]) return simpleMatch[1].trim();

  return defaultFilename;
}
